module.exports = __webpack_public_path__ + "img/41.31e4d432.jpg";